<template>
  <form>
    <div class="image-container mb-3" v-if="previewPath">
      <img :src="previewPath" alt="Uploaded Image Preview" />
    </div>
    <div class="form-group">
      <div ref="dashboardContainer"></div>
    </div>
    <!-- <v-btn :disabled="disabled" @click.prevent="confirmUpload" class="btn btn-primary btn-block mb-2">Confirm upload</v-btn> -->
  </form>
</template>

<script>
import HeicToJpeg from "@/plugins/uppyHeicToJpeg";
import Uppy from "@uppy/core";

import Dashboard from "@uppy/dashboard";
import { nativeCameraOptions } from "@/utils/uppyCamera";
import Russian from "@uppy/locales/lib/ru_RU";
import English from "@uppy/locales/lib/en_US";
import { s3PublicUrl } from "@/utils/s3PublicUrl";
import { AwsS3Multipart, uploadedKey } from "@/utils/uppyS3Multipart";
import "@uppy/core/css/style.css";
import "@uppy/dashboard/css/style.css";
import { RASTER_IMAGE_AND_DOCUMENT_TYPES } from "@/utils/uploadFileTypes";

export default {
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: true,
    },
    editedClient: {
      type: Object,
    },
    width: {
      required: true,
    },
    height: {
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payload: null,
      previewPath: null,
      disabled: true,
    };
  },
  mounted() {
    this.instantiateUppy();
  },
  beforeDestroy() {
    this.uppy.destroy();
  },
  methods: {
    instantiateUppy() {
      this.uppy = new Uppy({
        debug: false,
        locale: this.$i18n.locale === "ru" ? Russian : English,
        autoProceed: true,
        allowMultipleUploadBatches: true,
        restrictions: {
          maxFileSize: this.maxFileSizeInBytes,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 5,
          allowedFileTypes: RASTER_IMAGE_AND_DOCUMENT_TYPES,
        },
      })
        .use(HeicToJpeg, { quality: 0.92 })
        .use(Dashboard, {
          ...nativeCameraOptions(),
          hideUploadButton: true,
          theme: this.theme,
          inline: true,
          width: this.width,
          height: this.height,
          target: this.$refs.dashboardContainer,
          browserBackButtonClose: true,
          proudlyDisplayPoweredByUppy: false,
        })
        .use(AwsS3Multipart, {
          limit: 5,
          companionEndpoint: `${this.$store.getters.getApiUrl}/cars`, // FT-018
        });

      this.uppy.on("complete", (event) => {
        event.successful.forEach((element) => {
          if (element !== undefined) {
            this.axios
              .post(
                `/api/v1/cars_files/${this.$route.params.id}`,
                {
                  cars_files: {
                    name: uploadedKey(element),
                    url: s3PublicUrl(uploadedKey(element)),
                    original_name: element.name,
                    document_type: element.type,
                  },
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then((response) => {
                console.log("updateCarsFiles")
                this.$emit("updateCarsFiles", {
                  id: response.data.id,
                  name: element.name,
                  url: element.response.uploadURL,
                  original_name: element.name,
                  document_type: element.type,
                });
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.error"));
              });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.image-container>img {
  width: inherit;
  height: inherit;
}
</style>
